import { useState } from "react";
import { Modal, Radio } from "antd";
import dayjs from "dayjs";

const style = {
  display: "flex",
  flexDirection: "column",
  marginTop: 10,
  gap: 12,
};

const MultipleItems = ({
  is_open,
  date,
  format,
  issues,
  tasks,
  setDraggableEvent,
  handleConfirmDrag,
}) => {
  const default_value =
    issues.length > 0 ? `issue|${issues[0].id}` : `task|${tasks[0].id}`;

  const [data_to_update, setDataTpUpdate] = useState(default_value);
  return (
    <Modal
      style={{ top: 45 }}
      title="Potwierdzenie"
      open={is_open}
      onOk={() => {
        const [type, id] = data_to_update.split("|");
        handleConfirmDrag(id, type);
      }} 
      onCancel={() => setDraggableEvent(null)}
      cancelText="Anuluj"
      okText="Potwierdzam"
    >
      Wybierz zgłoszennie lub priorytet do przeniesiania na{" "}
      <strong>{dayjs(date).format(format)}</strong>
      <Radio.Group
        style={style}
        onChange={({ target }) => setDataTpUpdate(target.value)}
        value={data_to_update}
        options={[
          ...issues.map((issue) => ({
            label: `Zgłoszenie: ${issue.client_address}`,
            value: `issue|${issue.id}`,
          })),
          ...tasks.map((task) => ({
            label: `Priorytet: ${task.content}`,
            value: `task|${task.id}`,
          })),
        ]}
      />
    </Modal>
  );
};

export default MultipleItems;
